import { render, staticRenderFns } from "./page0.vue?vue&type=template&id=a278cd0a&scoped=true&"
import script from "./page0.vue?vue&type=script&lang=js&"
export * from "./page0.vue?vue&type=script&lang=js&"
import style0 from "./page0.vue?vue&type=style&index=0&id=a278cd0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a278cd0a",
  null
  
)

export default component.exports